module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress",
    style: ('margin-top:' + _vm.playHeight + 'px'),
    attrs: {
      "id": "progress"
    }
  }, [_c('div', {
    staticClass: "progressbg"
  }), _vm._v(" "), _c('div', {
    staticClass: "progressfg",
    style: ('background-image:url(' + _vm.imgPath + 'home/loadingbg.png)')
  }), _vm._v(" "), _c('div', {
    staticClass: "progressimgbg"
  }, [_c('img', {
    staticClass: "progressimg",
    attrs: {
      "src": _vm.imgPath + 'home/loadingImg.png'
    }
  })]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "progressText"
  }, [_vm._v("\n\t\tloading"), _c('span', {
    staticClass: "progressTextdot"
  }, [_vm._v(".....")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efb5681c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/proGress.vue
// module id = 338
// module chunks = 0